import { getAssetPath } from "@stencil/core";
import mapboxgl from "mapbox-gl";

const legendItems = [
	{
		image:
			"https://sitenna-public-downloads.s3.eu-west-2.amazonaws.com/sitenna-asset/icons/map-icon/streetasset_icon.svg",
		name: "Street Asset",
	},
	{
		image:
			"https://sitenna-public-downloads.s3.eu-west-2.amazonaws.com/sitenna-asset/icons/map-icon/rooftop_icon.svg",
		name: "Rooftop",
	},
	{
		image:
			"https://sitenna-public-downloads.s3.eu-west-2.amazonaws.com/sitenna-asset/icons/map-icon/tower_icon.svg",
		name: "Tower",
	},
	{
		image:
			"https://sitenna-public-downloads.s3.eu-west-2.amazonaws.com/sitenna-asset/icons/map-icon/greenfield_icon.svg",
		name: "Greenfield",
	},
];

// create a button to toggle the legend
const button = () => {
	const btn = document.createElement("button");
	btn.style.backgroundImage = `url(${getAssetPath("assets/info.svg")})`;
	return btn;
};

// create a legend
const legend = (items: { image: string; name: string }[]) => {
	const list = document.createElement("ul");

	for (const item of items) {
		const listItem = document.createElement("li");
		const colorIcon = document.createElement("img");
		colorIcon.src = item.image;
		colorIcon.alt = item.name;
		listItem.appendChild(colorIcon);
		listItem.appendChild(document.createTextNode(item.name));
		list.appendChild(listItem);
	}

	return list;
};

export default class MapLegendControl implements mapboxgl.IControl {
	button: HTMLButtonElement;
	container: HTMLDivElement;
	legend: HTMLUListElement;

	onAdd() {
		this.container = document.createElement("div");
		this.container.className =
			"mapboxgl-ctrl mapboxgl-ctrl-group mapboxgl-ctrl-legend";
		this.button = button();
		this.legend = legend(legendItems);

		this.container.appendChild(this.legend);
		this.container.appendChild(this.button);

		this.button.addEventListener("click", () => {
			this.legend.style.display =
				this.legend.style.display === "block" ? "none" : "block";
		});

		return this.container;
	}

	onRemove() {
		this.container.parentNode.removeChild(this.container);
		this.container = null;
	}
}
